import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";

import CmsLandingPage from "./cms_new/public/CmsLandingPage";
import CmsPublicView from "./cms_new/public/CmsPublicView";

/**
 * The public portal intentionally has only two concerns:
 * render the new CMS and honour URLs that were published before the relaunch.
 */
export default function App() {
  return (
    <Switch>
      {/* Published legacy addresses */}
      <Redirect
        exact
        from="/mulfingen/Hollenbach"
        to="/mulfingen/11917/startseite"
      />
      <Redirect
        exact
        from="/kaisersbach/Ortsmitte"
        to="/kaisersbach/11671/startseite"
      />
      <Redirect
        exact
        from="/stockach/oberstadt/seite/jetzt-beteiligen"
        to="/stockach/11377/startseite"
      />
      <Redirect
        exact
        from="/stockach/oberstadt"
        to="/stockach/11377/startseite"
      />
      <Redirect
        exact
        from="/meckenbeuren/beteiligung"
        to="/meckenbeuren/11988/startseite"
      />
      <Redirect
        exact
        from="/ehingen/ehingen/participate"
        to="/ehingen/11963/startseite"
      />
      <Redirect exact from="/ehingen/ehingen" to="/ehingen/11963/startseite" />
      <Redirect
        exact
        from="/dornhan/malischstrasse"
        to="/dornhan/11944/startseite"
      />
      <Redirect
        exact
        from="/dornhan/malischstrasse/Untersuchungen-und-Sanierung"
        to="/dornhan/11944/startseite"
      />

      <Route exact path="/" component={CmsLandingPage} />
      <Route exact path="/p/:siteSlug" component={CmsPublicView} />
      <Route exact path="/p/:siteSlug/:pageSlug" component={CmsPublicView} />
      <Route
        exact
        path="/:mandantKey/:projectNumber/:pageSlug?"
        component={CmsPublicView}
      />
      <Redirect to="/" />
    </Switch>
  );
}
